import { render, staticRenderFns } from "./PopupProjectEdit.vue?vue&type=template&id=6f6d6a52"
import script from "./PopupProjectEdit.vue?vue&type=script&lang=ts"
export * from "./PopupProjectEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports